export default __webpack_public_path__ + "static/media/arduino.44cdddb7.PNG";